export function setNewObjectToCreateChart(deselecteds, chartData) {
    // 1. Find the indexes of deselected series
    const deselectedIndexes = deselecteds.map(d => chartData.data.series.findIndex(series => series.name === d.name)).filter(idx => idx !== -1);

    // 2. Remove deselected series and labels
    deselectedIndexes.sort((a, b) => b - a).forEach(idx => {
        chartData.data.series.splice(idx, 1);
        chartData.data.labeled.labels.splice(idx, 1);
        chartData.data.labeled.series.splice(idx, 1);
    });

    // 3. Recalculate totals by categories
    const totalByCategories = {};
    chartData.data.categories.forEach((cat, catIdx) => {
        totalByCategories[cat] = chartData.data.series.reduce((acc, currSeries) => acc + currSeries.data[catIdx], 0);
    });

    // Remove empty categories
    for (let cat in totalByCategories) {
        if (totalByCategories[cat] === 0) {
            const idxToRemove = chartData.data.categories.indexOf(cat);
            if (idxToRemove !== -1) {
                chartData.data.categories.splice(idxToRemove, 1);
                chartData.data.series.forEach(s => s.data.splice(idxToRemove, 1));
            }
        }
    }

    return chartData;
}